export const DEFAULT_DROPDOWN_TITLE = "Industry Hub";
